export type LocalSubflowStep = Record<string, unknown>;

export type LocalSubflowStepNode = {
  step: LocalSubflowStep;
  depth: number;
  siblingIndex: number;
};

const childStepsFor = (step: LocalSubflowStep): LocalSubflowStep[] => {
  const directChildren = Array.isArray(step.children) ? step.children : [];
  const handlerChildren = Array.isArray(step.handler_children) ? step.handler_children : [];
  const conditionalChildren = Array.isArray(step.conditions)
    ? step.conditions.flatMap((condition) => {
        const value = condition as LocalSubflowStep;
        return Array.isArray(value.children) ? value.children : [];
      })
    : [];
  return [...directChildren, ...handlerChildren, ...conditionalChildren].filter(
    (child): child is LocalSubflowStep => typeof child === 'object' && child !== null,
  );
};

export const flattenLocalSubflowSteps = (
  steps: LocalSubflowStep[],
  depth = 0,
): LocalSubflowStepNode[] =>
  steps.flatMap((step, siblingIndex) => [
    { step, depth, siblingIndex },
    ...flattenLocalSubflowSteps(childStepsFor(step), depth + 1),
  ]);

export const findLocalSubflowStep = (steps: LocalSubflowStep[], stepId: string) =>
  flattenLocalSubflowSteps(steps).find((node) => String(node.step.step_id ?? '') === stepId)?.step;

export const isNestedLocalSubflowStep = (steps: LocalSubflowStep[], stepId: string) =>
  (flattenLocalSubflowSteps(steps).find((node) => String(node.step.step_id ?? '') === stepId)?.depth ?? 0) > 0;
